import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const UsersPage = lazy(() => import('../../pages/users/users'));

// ----------------------------------------------------------------------

export const usersRoutes: RouteObject[] = [
  {
    path: 'users',
    element: CONFIG.auth.skip ? (
      <Suspense fallback={<LoadingScreen />}>
        <DashboardLayout>
          <UsersPage />
        </DashboardLayout>
      </Suspense>
    ) : (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <DashboardLayout>
            <UsersPage />
          </DashboardLayout>
        </Suspense>
      </AuthGuard>
    ),
  },
];
